import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions, Typography, IconButton
} from '@mui/material/'
//import FmdBadIcon from '@mui/icons-material/FmdBad';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import Button from "@mui/material/Button";

export default function ConfirmDialog(props) {


    const {
        isOpen = false,
        title = "",
        subTitle = "",
        negativeAction = "",
        onClose = () => { },
        positiveReq = false,
        iconReq = true,
        iconContent="",
        negativeReq = true,
        positiveAction = "",
        onSubmit = () => { },
        cancelExtra = false,
        onCancel = () => { },
        outsideClickedDismiss = true,
    } = props;

    const handleCancel = (event) => {
        //console.log("handleCancel=>",cancelExtra);
        if (cancelExtra) {
            if (onCancel)
                onCancel(event);
        } else
            onClose(event);    
    };

    const handleClose = (event) => {
        //console.log("handleClose=>",outsideClickedDismiss);
        if (outsideClickedDismiss)
            onClose(event);
    };

    const handleSubmit = (event) => {
        //console.log("sknd");
        if (onSubmit)
            onSubmit(event);
    };

    return (
        <Dialog open={isOpen} sx={{
            padding: 10,
            position: 'absolute',
            top: 5,

        }}
            onClose={handleClose}>
            <DialogTitle sx={{
                textAlign: 'center',
            }}>
                {
                    iconReq &&
                        <IconButton disableRipple sx={{
                            backgroundColor: 'background.paper',
                            color: 'primary.default',
                            '&:hover': {
                                backgroundColor: 'background.paper',
                                cursor: 'default'
                            },
                            '& .MuiSvgIcon-root': {
                                fontSize: '8rem',
                            }
                        }}>
                            <PriorityHighIcon />
                        </IconButton> 
                }
                {
                    iconContent &&
                        <IconButton disableRipple sx={{
                            backgroundColor: 'background.paper',
                            color: 'primary.default',
                            '&:hover': {
                                backgroundColor: 'background.paper',
                                cursor: 'default'
                            },
                            '& .MuiSvgIcon-root': {
                                fontSize: '8rem',
                            }
                        }}>
                            {iconContent}
                        </IconButton> 
                }
            </DialogTitle>
            <DialogContent sx={{
                textAlign: 'center',
            }}>
                <Typography variant="h6">
                    {title}
                </Typography>
                <Typography variant="subtitle2">
                    {subTitle}
                </Typography>
            </DialogContent>
            <DialogActions sx={{
                justifyContent: 'center',
            }}>
                {
                    negativeReq ?
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleCancel}>
                            {negativeAction === '' ? "No" : negativeAction}
                        </Button> : null
                }

                {
                    positiveReq ?
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}>
                            {positiveAction === '' ? "Yes" : positiveAction}
                        </Button>
                        : null
                }
            </DialogActions>
        </Dialog>
    )
}